export const MerchandisingPermissions = {
  
  "Deputy General Manager": [
    {
      path: "/merchandising/purchase-contracts",
      label: "PC/JOBS",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/techpacks",
      label: "Techpacks",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/sors",
      label: "SOR'S",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/costings",
      label: "BOM & Costings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/purchases",
      label: "PO",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/budgets",
      label: "Budgets",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/bookings-overview",
      label: "Bookings Overview",
      icon: "fas fa-chevron-right me-1",
    },

    {
      path: "/merchandising/bookings",
      label: "Bookings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/proformas-overview",
      label: "PI Overview",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/proformas",
      label: "PI",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/store/store-summary",
      label: "Store Summary",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/stores",
      label: "Sample Store",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  Manager: [
    {
      path: "/merchandising/techpacks",
      label: "Techpacks",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/sors",
      label: "SOR'S",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/costings",
      label: "BOM & Costings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/purchases",
      label: "PO",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/budgets",
      label: "Budgets",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/bookings-overview",
      label: "Bookings Overview",
      icon: "fas fa-chevron-right me-1",
    },

    {
      path: "/merchandising/bookings",
      label: "Bookings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/proformas-overview",
      label: "PI Overview",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/proformas",
      label: "PI",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/store/store-summary",
      label: "Store Summary",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/stores",
      label: "Sample Store",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Assistant Manager": [
    {
      path: "/merchandising/techpacks",
      label: "Techpacks",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/sors",
      label: "SOR'S",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/costings",
      label: "BOM & Costings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/purchases",
      label: "PO",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/budgets",
      label: "Budgets",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/bookings-overview",
      label: "Bookings Overview",
      icon: "fas fa-chevron-right me-1",
    },

    {
      path: "/merchandising/bookings",
      label: "Bookings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/proformas-overview",
      label: "PI Overview",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/proformas",
      label: "PI",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/store/store-summary",
      label: "Store Summary",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/stores",
      label: "Sample Store",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  Merchandiser: [
    {
      path: "/merchandising/techpacks",
      label: "Techpacks",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/sors",
      label: "SOR'S",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/costings",
      label: "BOM & Costings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/purchases",
      label: "PO",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/budgets",
      label: "Budgets",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/bookings-overview",
      label: "Bookings Overview",
      icon: "fas fa-chevron-right me-1",
    },

    {
      path: "/merchandising/bookings",
      label: "Bookings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/proformas-overview",
      label: "PI Overview",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/proformas",
      label: "PI",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/store/store-summary",
      label: "Store Summary",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/stores",
      label: "Sample Store",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Sr. Merchandiser": [
    {
      path: "/merchandising/techpacks",
      label: "Techpacks",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/sors",
      label: "SOR'S",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/costings",
      label: "BOM & Costings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/purchases",
      label: "PO",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/budgets",
      label: "Budgets",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/bookings-overview",
      label: "Bookings Overview",
      icon: "fas fa-chevron-right me-1",
    },

    {
      path: "/merchandising/bookings",
      label: "Bookings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/proformas-overview",
      label: "PI Overview",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/proformas",
      label: "PI",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/store/store-summary",
      label: "Store Summary",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/stores",
      label: "Sample Store",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Asst. Merchandiser": [
    {
      path: "/merchandising/techpacks",
      label: "Techpacks",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/sors",
      label: "SOR'S",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/costings",
      label: "BOM & Costings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/purchases",
      label: "PO",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/budgets",
      label: "Budgets",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/bookings-overview",
      label: "Bookings Overview",
      icon: "fas fa-chevron-right me-1",
    },

    {
      path: "/merchandising/bookings",
      label: "Bookings",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/proformas-overview",
      label: "PI Overview",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/proformas",
      label: "PI",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/store/store-summary",
      label: "Store Summary",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/sample/stores",
      label: "Sample Store",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
};
